import ApiModelWithAuth from "../../../models/ApiModelWithAuth";
import Formatter from "../../../models/Formatter";

export class RedroidScriptFormatter extends Formatter {
}

// Каталог скриптов ЧЕРЕЗ android-сервис (App\Models\RedroidScript, AndroidFarm/run.py —
// reboot/reset и т.п., authorized/admin/devices/redroid-scripts) — read + редактирование label,
// kind='device' (тот же пикер, что ApiDeviceScript — прямые adb/ssh-скрипты).
export default class ApiRedroidScript extends ApiModelWithAuth {
    pathDef = 'authorized/admin/devices/redroid-scripts';
    formatterItem = RedroidScriptFormatter.Item;
}
